module.exports = __webpack_public_path__ + "img/cosmos.2d969e3e.jpg";